function toDashCase(input) {
    return input.replace(/([A-Z])/g, "-$1").toLowerCase();
}
const CODEC_OPTION_TYPES = {
    repeatPreviousFrameAfter: "long",
    maxPtsGapToEncoder: "long",
};
export class CodecOptions {
    value;
    constructor(value = {}) {
        this.value = value;
    }
    toOptionValue() {
        const entries = Object.entries(this.value).filter(([, value]) => value !== undefined);
        if (entries.length === 0) {
            return undefined;
        }
        return entries
            .map(([key, value]) => {
            const type = CODEC_OPTION_TYPES[key];
            return `${toDashCase(key)}${type ? `:${type}` : ""}=${value}`;
        })
            .join(",");
    }
}
//# sourceMappingURL=codec-options.js.map